export default __webpack_public_path__ + "static/media/N_wdt_c_cap_3.2ad92daf.mp3";